export default {
    deviceName: 'Device Name',
    deviceNumber: 'Device Number',
    recordTime: 'Record Time',
    mapViewAll: 'Map View All',
    distance: 'Distance',
    flightAltitude: 'Flight altitude (relative altitude)',
    positionCoordinates: 'Position Coordinates',
    copyLocationData: 'Copy Location Data',
    detectionRecord: 'Detection Record',
    signalStrength: 'Signal Strength',
}